var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("mux-player", {
    attrs: {
      "playback-id": _vm.playbackId,
      "metadata-video-title": _vm.videoTitle,
      "accent-color": _vm.accentColor,
      "primary-color": _vm.primaryColor,
      "secondary-color": _vm.secondaryColor,
      poster: _vm.posterImageUrl,
      autoplay: _vm.autoplay,
      muted: _vm.muted,
      loop: _vm.loop,
      controls: _vm.controls,
      playsinline: "true",
      disablePictureInPicture: "true",
      "disable-cookies": "true",
      "stream-type": "on-demand",
      preload: "auto"
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };